import { render, staticRenderFns } from "./identitycontrol.vue?vue&type=template&id=05ae35a8&scoped=true&"
import script from "./identitycontrol.vue?vue&type=script&lang=js&"
export * from "./identitycontrol.vue?vue&type=script&lang=js&"
import style0 from "./identitycontrol.vue?vue&type=style&index=0&id=05ae35a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ae35a8",
  null
  
)

export default component.exports